import { c as _c } from "react/compiler-runtime";
import styles from "@website/icons/material/material.module.scss";
import { MaterialIconPropertiesType } from "@website/icons/material/material.types";
import omit from "lodash-es/omit";
import { FC } from "react";
export const MaterialIcon: FC<MaterialIconPropertiesType> = properties => {
  const $ = _c(7);
  const {
    className,
    name,
    variant,
    datatestid
  } = properties;
  const t0 = `${styles.icon} ${styles[variant || "fill"]} ${className ?? ""}`;
  let t1;
  if ($[0] !== properties) {
    t1 = omit(properties, "name", "className", "variant");
    $[0] = properties;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = typeof jest === "object" && typeof test === "function" ? "" : name;
  let t3;
  if ($[2] !== datatestid || $[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = <span className={t0} data-nosnippet={true} data-testid={datatestid} {...t1}>{t2}</span>;
    $[2] = datatestid;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};